<template>
  <div>
    <span v-if="this.$route.query.edit">
      <doe-button
        action="form:previous"
        size="large"
        appearance="secondary"
        label="Cancel"
        @click="clickFormActions"
      />
      <doe-button
        action="form:next"
        size="large"
        appearance="primary"
        label="Update"
        @click="clickFormActions"
      />
    </span>
    <doe-button
      v-else
      v-for="(button, index) in buttons"
      :disabled="formValid"
      :skippable="button.skippable"
      :action="button.action"
      :size="button.size"
      :prefix="button.prefix"
      :suffix="button.suffix"
      icon-size="small"
      :appearance="button.appearance"
      :key="index"
      :label="button.label"
      :id="button.id"
      @click="clickFormActions"
    />
  </div>
</template>

<script>
import DoeButton from "@/components/button/Button";

export default {
  name: "FormActions",
  props: {
    formValid: {
      type: Boolean
    },
    buttons: {
      type: Array,
      required: true
    }
  },
  components: {
    DoeButton
  },
  methods: {
    clickFormActions(payload) {
      this.$emit("click", payload);
    }
  }
};
</script>

<style lang="scss" scoped>
button:first-of-type {
  margin-bottom: 20px;
  margin-right: 20px;
}
</style>
